/**
 * This only exists since order is crucial
 */
export function arraysAreIdentical(a: string[], b: string[]) {
    if (a.length !== b.length) return false;
    return a.every((val, index) => val === b[index]);
}
